/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Metadata for required work whose tool exhausted its retry policy.
 */
export type EmployeeExecutionRepeatedToolFailureBlocker = {
    /**
     * Deterministic blocker classification.
     */
    category: EmployeeExecutionRepeatedToolFailureBlocker.category;
    /**
     * Sanitized human-readable explanation without raw tool output.
     */
    reason: string;
    /**
     * Tool whose equivalent typed failures exhausted the retry policy.
     */
    toolName: string;
    /**
     * Number of equivalent failed attempts observed by the runtime.
     */
    attempts: number;
    /**
     * ISO timestamp when the runtime determined that progress was blocked.
     */
    occurredAt: string;
};
export namespace EmployeeExecutionRepeatedToolFailureBlocker {
    /**
     * Deterministic blocker classification.
     */
    export enum category {
        REPEATED_TOOL_FAILURE = 'repeated-tool-failure',
    }
}

